const indexItems = [
  { title: '娱乐圈爆料合集', desc: '明星、演员、歌手相关的51吃瓜爆料汇总', count: '186篇' },
  { title: '网红圈黑料实锤', desc: '知名网红、主播的51吃瓜黑料内容', count: '142篇' },
  { title: '综艺节目内幕', desc: '热门综艺录制花絮与51吃瓜今日黑料视频', count: '98篇' },
  { title: '品牌代言风波', desc: '商业代言相关的51吃瓜最新爆料', count: '76篇' },
  { title: '直播事故现场', desc: '各大平台直播间的51吃瓜爆料合集', count: '65篇' },
  { title: '选秀比赛黑幕', desc: '各类选秀节目的51吃瓜黑料汇总', count: '54篇' },
  { title: '私生饭追踪事件', desc: '私生饭行为引发的51吃瓜最新爆料讨论', count: '43篇' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1024px] mx-auto">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          专题索引
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">
          51吃瓜爆料内容分类导览
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item, i) => (
            <div
              key={i}
              className="flex items-start gap-4 p-4 bg-background-100 rounded-xl border border-background-200/70 hover:border-background-300 transition-colors cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 font-heading font-bold text-sm flex-shrink-0">
                {i + 1}
              </div>
              <div className="min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-heading font-semibold text-sm text-foreground-900 truncate">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-400 whitespace-nowrap flex-shrink-0">{item.count}</span>
                </div>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}